import { defineStore } from 'pinia';
import { computed } from 'vue';

import { useBrowserStore } from '@apps/main/new-desktop/core/stores/browserStore';
import { useActivityDetailsStore } from '@apps/main/new-desktop/core/stores';

import type { ActivityDetailsHeaderData, GalleryType } from '../models';

import {
  getActivityDetailsHeaderData,
  getGalleryType,
} from './activityDetailsStoreLogic';

export const useActivityDetailsPanelStore = defineStore(
  'ActivityDetailsPanelStore',
  () => {
    const browserStore = useBrowserStore();
    const activityDetailsStore = useActivityDetailsStore();

    // Getters
    const headerData = computed<ActivityDetailsHeaderData | undefined>(() =>
      getActivityDetailsHeaderData(
        activityDetailsStore.activityDetailsStaticData
      )
    );

    const galleryType = computed<GalleryType>(() =>
      getGalleryType(browserStore.isSmallerThan900px)
    );

    return {
      // Getters
      galleryType,
      headerData,
    };
  }
);
